export const INIT = '@@INIT';

export interface Init {
  type: typeof INIT;
  payload?: void;
}

// RegisterFirm

export const ADD_FIRM_DATA = 'REGISTER_FIRM/ADD_FIRM_DATA';
export const RESET_FIRM_DATA = 'REGISTER_FIRM/RESET_FIRM_DATA';

// RegisterNetwork
export const ADD_NETWORK_DATA = 'REGISTER_NETWORK/ADD_NETWORK_DATA';
export const CLEAR_NETWORK_FORM = 'REGISTER_NETWORK/CLEAR_FORM';
export const ADD_NEW_ADDRESS_NETWORK_FORM = 'REGISTER_NETWORK/ADD_NEW_ADDRESS';

// Login

export const LOG_IN_USER = 'LOGIN/LOG_IN_USER';
export const LOG_OUT_USER = 'LOGOUT/LOG_OUT_USER';
export const SET_LOGIN_ERROR = 'LOGIN/SET_LOGIN_ERROR';
export const RESET_LOGIN_ERROR = 'LOGIN/RESET_LOGIN_ERROR';
export const RESTORE_PERMISSIONS_FROM_STORAGE = 'LOGIN/RESTORE_PERMISSIONS_FROM_STORAGE';
export const LOGIN_SET_ADMIN_ACCESS = 'LOGIN/SET_ADMIN_ACCESS';
